import React from "react";
import { InputText } from "primereact/inputtext";

const SearchBar = ({ searchTerm, setSearchTerm }) => {
  return (
    <span className="p-input-icon-left w-full">
      <i className="pi pi-search ml-3" />
      <InputText
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        placeholder="Search by Transaction ID"
        className="w-full"
        style={{ paddingLeft: "2.5rem" }}
      />
    </span>
  );
};

export default SearchBar;
